import { useMemo } from 'react';
import { useBucket } from '@context/bucket.context';

export const useFacebookAdjustTracking = () => {
  const { isFeatureEnabled } = useBucket();
  const enableSmartBannerParameter = isFeatureEnabled((f) => f.smartBannerParameter, true);
  const isFbAdsAdjustTrackingEnabled = isFeatureEnabled((f) => f.enableFbAdsAdjustTracking, true);

  const isFromFacebookAd = useMemo(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    const utmSource = urlParams.get('utm_source')?.toLowerCase();
    const utmMedium = urlParams.get('utm_medium')?.toLowerCase();

    const validMediums = ['paid_social', 'prospecting'];

    return !!fbclid && utmSource === 'facebook' && validMediums.includes(utmMedium);
  }, []);

  // Build Adjust URL for Facebook clicks with fbclid and macros
  const getFacebookAdjustUrl = () => {
    if (typeof window === 'undefined') {
      return '';
    }

    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');

    const campaign = urlParams.get('adj_campaign');
    const adgroup = urlParams.get('adj_adgroup');
    const creative = urlParams.get('adj_creative');
    const token = urlParams.get('adj_t');
    const smartBannerParams = enableSmartBannerParameter
      ? '&adj_engagement_type=fallback_click&adj_label=smartbanner'
      : '';

    const adjLinkBase = 'https://wj62.adj.st/action?type=start';
    const adjToken = token ? `&adj_t=${token}` : '';
    const deeplinkParam = `&adj_deep_link=com.vestiairecollective.vestiaire%3A%2F%2Faction%3Ftype%3Dwebbanner%26url%3D${encodeURIComponent(
      window.location.href,
    )}`;

    const adjustParams = new URLSearchParams({
      adj_campaign: campaign,
      adj_group: adgroup,
      adj_creative: creative,
      fbclid: fbclid,
    }).toString();

    const url = `${adjLinkBase}${adjToken}${smartBannerParams}${deeplinkParam}&${adjustParams}`;
    return url;
  };

  return {
    isFbAdsAdjustTrackingEnabled,
    isFromFacebookAd,
    getFacebookAdjustUrl,
  };
};
